import { useRouteError } from 'react-router-dom';

import errorBadge from '@/assets/images/errors/error-badge.webp';
import { Button } from '@/components/common/button';
import { isDynamicImportError } from '@/routes/lazy-route';

import styles from './route-error.page.module.scss';

/**
 * Route-level `errorElement`. Catches loader/lazy/render errors that React
 * Router would otherwise show as its unstyled dev default (bug 110529). For a
 * stale-chunk failure that survived the one-shot auto-reload, we offer a manual
 * reload; for anything else, a generic recovery affordance.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const isChunkError = isDynamicImportError(error);

  // Figma Webstore-Design `1935:508379`. Rendered outside the app shell on purpose — it is the
  // root `errorElement`, so it must still draw when the shell itself is what failed.
  return (
    <main className={styles.page}>
      <img className={styles.badge} src={errorBadge} alt="" width={96} height={96} />
      <div className={styles.copy}>
        <h1 className={styles.title}>Something went wrong</h1>
        <p className={styles.body}>
          {isChunkError
            ? "We couldn't load this page. A new version may have just been released — reloading usually fixes it."
            : 'An unexpected error occurred while loading this page.'}
        </p>
      </div>
      <Button variant="neutral" onClick={() => window.location.reload()}>
        Reload page
      </Button>
    </main>
  );
}
